import { render, staticRenderFns } from "./SavingsWidget.vue?vue&type=template&id=5f574bfd&"
import script from "./SavingsWidget.vue?vue&type=script&lang=js&"
export * from "./SavingsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports